export default __webpack_public_path__ + "static/media/gallery_17.b820f315.jpg";